var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSanteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.733,
    height: 20.756,
    viewBox: "0 0 14.733 20.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M2795.632,764.638a10.274,10.274,0,0,0-1.609-5.525l-4.49-7.055a1.207,1.207,0,0,0-2.036,0l-4.49,7.055a10.277,10.277,0,0,0-1.609,5.525,7.117,7.117,0,0,0,14.233,0Zm-7.117,6.346a6.353,6.353,0,0,1-6.346-6.346,9.5,9.5,0,0,1,1.489-5.112l4.441-6.978a.494.494,0,0,1,.833,0l4.441,6.978a9.512,9.512,0,0,1,1.488,5.112A6.353,6.353,0,0,1,2788.515,770.983Z",
    transform: "translate(-2781.399 -751.498)",
    fill: "#ff4e4e",
    stroke: "#ff4e4e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M2884.573,970.412h0a.506.506,0,0,0-.507.507v2.021h-2.021a.506.506,0,0,0-.506.506h0a.507.507,0,0,0,.506.507h2.021v2.021a.506.506,0,0,0,.507.507h0a.506.506,0,0,0,.506-.507v-2.021h2.021a.507.507,0,0,0,.506-.507h0a.507.507,0,0,0-.506-.506h-2.021v-2.021A.506.506,0,0,0,2884.573,970.412Z",
    transform: "translate(-2877.456 -960.627)",
    fill: "#ff4e4e",
    stroke: "#ff4e4e",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanteIcon);
export default __webpack_public_path__ + "static/media/sante-icon.883544a58ccbcce83288ccd634582fe7.svg";
export { ForwardRef as ReactComponent };